import { callApi } from './apiService';
import { UAParser } from 'ua-parser-js';

/**
 * Extrai informações do dispositivo a partir do user-agent.
 * @returns {string} Uma string descrevendo o dispositivo (ex: "Chrome on Windows").
 */
const getDevice = () => {
    try {
        const parser = new UAParser();
        const result = parser.getResult();
        const browser = result.browser.name || 'Navegador desconhecido';
        const os = result.os.name || 'SO desconhecido';
        const device = result.device.model || result.device.vendor;

        if (device) {
            return `${device} (${os})`;
        }
        return `${browser} em ${os}`;
    } catch (error) {
        console.error("Erro ao parsear o user-agent:", error);
        return 'Dispositivo desconhecido';
    }
};

/**
 * Envia um log de login para o backend.
 * @param {object} user - O objeto do usuário autenticado do Firebase.
 */
export const logLogin = async (user) => {
    if (!user) {
        console.warn("Tentativa de log de login sem usuário.");
        return;
    }

    const device = getDevice();

    try {
        await callApi('logLogin', {
            user: {
                uid: user.uid,
                email: user.email,
                displayName: user.displayName,
            },
            device: device,
        });
    } catch (error) {
        // O erro já é logado pelo callApi, mas podemos adicionar um log específico se quisermos.
        console.error("Falha ao enviar o log de login para o servidor:", error);
    }
};